import {
  callCallback,
  createContentRequest,
  stopLoadingShowError,
} from "../utils";
import * as tvx from "../lib/tvx-plugin-module.min";
import {
  MSXMenuRoot,
  MSXContentRoot,
  Tools,
  MSXContentItem,
  MSXContentPage,
} from "../lib/tvx-plugin-module.min";
import {
  res_all_in_one,
  res_click_to_search,
  res_home,
  res_more,
  res_no_results,
  res_search,
  res_search_background,
  res_search_for,
  res_search_results_for,
  res_search_total,
  res_serials,
  res_total_films_and_series,
  SERVER_ADDRESS,
} from "../static-res";
import { getPageCollections } from "../api/worker";
import {
  apiSearchResponse,
  apiSearchResultFiction,
  PagesEnum,
} from "../api/api-models";
import { createCollectionRow } from "./collections-row";
import { sendSearchAnalytics, generateVisitorId } from "../analytics";

function createResultItem(
  searchResult: apiSearchResultFiction
): MSXContentItem {
  return {
    type: "separate",
    image: searchResult.portraitImage,
    title: searchResult.title.toUpperCase(),
    action:
      "content:" +
      createContentRequest(
        `fiction:${searchResult.type}:${searchResult.imdbid}`
      ),
  };
}
function createFooterItem(): MSXContentPage {
  return {
    items: [
      {
        layout: "3,0,10,2",
        type: "teaser",
        title: res_more(),
        centration: "title",
        alignment: "center",
        action: "interaction:commit:message:control:more",
      },
    ],
  };
}

export function createSearchResult(
  apiSearchResponse: apiSearchResponse,
  querry: string
): MSXContentPage {
  const resultPage: MSXContentPage = {
    type: "list",

    hint: `Results for: ${querry}`,
    items: [],
  };
  // --- АНАЛИТИКА ПОИСКА ---
  if (querry && apiSearchResponse.results && apiSearchResponse.results.length > 0) {
    const userId = localStorage.getItem("screenify:userId") || "unknown";
    sendSearchAnalytics({
      search_text: querry,
      userid: userId,
      visitorId: generateVisitorId(userId),
      email: localStorage.getItem("screenify:email") || "unknown",
    });
  }
  // --- КОНЕЦ АНАЛИТИКИ ---
  if (apiSearchResponse.results != undefined) {
    if (apiSearchResponse.results.length > 0) {
      (resultPage.headline = `{ico:search} ${res_search_results_for()}: ${querry} ${res_search_total()}: ${apiSearchResponse.pagination.totalResults}`),
        (resultPage.template = {
          type: "separate",
          layout: "0,0,3,6",
          imageFiller: "cover",
          selection: {
            headline: "{context:title}",
          },
        });
      apiSearchResponse.results.forEach((result) => {
        resultPage.items.push(createResultItem(result));
      });
      const page = apiSearchResponse.pagination.page;
      const totalPages = apiSearchResponse.pagination.totalPages;
      if (page < totalPages) {
        resultPage.footer = createFooterItem();
      }
    }
  } else {
    resultPage.headline = `{ico:search} ${res_no_results()}`;
    resultPage.template = {
      type: "separate",
      layout: "0,0,16,2",
      imageFiller: "cover",
      selection: {
        headline: "{context:title}",
      },
    };
    resultPage.items.push({
      type: "default",
      title: res_no_results(),
      centration: "title",
      alignment: "center",
    });
  }
  return resultPage;
}

export function createSearchRoot(callback: (data: any) => void): void {
  tvx.InteractionPlugin.stopLoading();
  getPageCollections(PagesEnum.SEARCH).then((searchPage) => {
    if (searchPage != null) {
      const collectionsWithFictions = searchPage.collections;

      const searchRoot: MSXContentRoot = {
        cache: true,
        restore: true,
        reuse: true,
        background: res_search_background,
        type: "list",
        headline: res_search(),
        flag: "search",
        important: true,
        pages: [
          {
            items: [
              {
                type: "default",
                layout: "1,0,10,1",
                title: res_total_films_and_series(),
                alignment: "center",
                centration: "title",
              },
              {
                separation: 0.9,
                type: "default",
                layout: "1,1,10,1",
                icon: "search",
                imageFiller: "cover",
                imageWidth: 1,
                centration: "title",
                title: res_click_to_search(),
                action: `content:request:interaction:search|${res_search_for()}|${res_search_background}@${SERVER_ADDRESS}input.html`,
              },
            ],
          },
        ],
      };
      collectionsWithFictions
        .sort((a, b) => a.position - b.position)
        .forEach((collectionWithFictions) => {
          searchRoot.pages.push(createCollectionRow(collectionWithFictions));
        });
      callCallback(searchRoot, callback);
    } else {
      console.log("error occured");

      stopLoadingShowError({}, callback);
    }
  });
}
